module.exports = __webpack_public_path__ + "static/media/ic-clock.89f90cd6.svg";